import * as stylex from "@stylexjs/stylex";
export const searchMarker = {
  xmamutd: "xmamutd",
  $$css: true
};
import "/home/runner/work/cf-effect-experiment/cf-effect-experiment/packages/vite-shared-libraries/src/LayerAnchors.ts";